<script>
// eslint-disable-next-line
import { ContentLoader } from 'vue-content-loader';

export default {
	components: { ContentLoader },
};
</script>

<template>
  <content-loader
    :width="90"
    :height="90"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="0" y="0" rx="2" ry="2" width="90" height="90" />
  </content-loader>
</template>
